import { render, staticRenderFns } from "./PendingAssignments.vue?vue&type=template&id=09d876b5"
import script from "./PendingAssignments.vue?vue&type=script&lang=js"
export * from "./PendingAssignments.vue?vue&type=script&lang=js"
import style0 from "./PendingAssignments.vue?vue&type=style&index=0&id=09d876b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSlideItem from 'quasar/src/components/slide-item/QSlideItem.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSlideItem,QCheckbox,QIcon,QSpinner});
